import { getOfficeApiOrigin } from '@/utils/meetingEnv';

const selectedOrigin = getOfficeApiOrigin(process.env.CUR_ENV);

// Production-mode bundles keep their existing same-origin API routing.
export const OFFICE_API_ORIGIN = process.env.NODE_ENV === 'production' ? '' : selectedOrigin;

const isLocalFrontend = (): boolean => {
  if (typeof window === 'undefined' || !window.location?.origin) {
    return false;
  }
  try {
    return ['localhost', '127.0.0.1', '[::1]'].includes(new URL(window.location.origin).hostname);
  } catch {
    return false;
  }
};

export const officeUrl = (path: string): string => {
  if (!OFFICE_API_ORIGIN) {
    return path;
  }
  const absolute = /^https?:\/\//i.test(path);
  const url = new URL(path, `${OFFICE_API_ORIGIN}/`);
  if (isLocalFrontend() && url.origin === OFFICE_API_ORIGIN && !url.username && !url.password && /^\/api\/(?:v2\/office|v1\/ai-worker)(?:\/|$)/.test(url.pathname)) {
    // Slicing href preserves signed queries and an empty '?' used by route checks.
    return url.href.slice(url.origin.length);
  }
  return absolute ? path : url.href;
};

// Accept relative and absolute wire URLs only within the expected Office route.
export const isOfficePath = (value: string, path: string, exact = false): boolean => {
  try {
    const base = typeof window === 'undefined' ? 'http://localhost' : window.location?.origin || 'http://localhost';
    const expected = new URL(officeUrl(path), base);
    const parsed = new URL(officeUrl(value), base);
    return parsed.origin === expected.origin && !parsed.username && !parsed.password && (exact ? parsed.href === expected.href : parsed.href.startsWith(expected.href));
  } catch {
    return false;
  }
};
